var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockedCircular = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#DBDBDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2793_13286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5V16.5C18.5 15.837 18.7634 15.2011 19.2322 14.7322C19.7011 14.2634 20.337 14 21 14C21.663 14 22.2989 14.2634 22.7678 14.7322C23.2366 15.2011 23.5 15.837 23.5 16.5V18.5M16 18.5H26C26.2761 18.5 26.5 18.7239 26.5 19V26C26.5 26.2761 26.2761 26.5 26 26.5H16C15.7239 26.5 15.5 26.2761 15.5 26V19C15.5 18.7239 15.7239 18.5 16 18.5Z",
    stroke: "#0D0C0C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2793_13286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(13 13)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockedCircular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LockedCircular.fc50672c3360d0ebd33c4c62e38d9bd3.svg";